import { render, staticRenderFns } from "./team-admin-detail.vue?vue&type=template&id=e894615e&scoped=true&"
import script from "./team-admin-detail.vue?vue&type=script&lang=js&"
export * from "./team-admin-detail.vue?vue&type=script&lang=js&"
import style0 from "./team-admin-detail.vue?vue&type=style&index=0&id=e894615e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e894615e",
  null
  
)

export default component.exports